function FormTextArea(props: any) {
  return (
    <div className="EditForm">
      <label className="EditLabel">{props.title}</label>
      <div className="EditInputHolder">
        <textarea {...props} />
      </div>
    </div>
  );
}

export default FormTextArea;
